import { ReactNode } from 'react';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './carousel.scss';

export const Carousel = ({
  name,
  className = '',
  children,
}: {
  name?: string;
  className?: string;
  children: ReactNode[];
}) => {
  const settings: Settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    infinite: false,
    rows: 1,
    dots: false,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
    // nextArrow: (
    //   <button id="slick-next-custom-arrow" type="button">
    //     {/* <span className="icon icon-chevron-left" aria-hidden="true"></span> */}
    //   </button>
    // ),
    // prevArrow: (
    //   <button id="slick-prev-custom-arrow" type="button">
    //     {/* <span className="icon icon-chevron-right" aria-hidden="true"></span> */}
    //   </button>
    // ),
  };

  return children.length > 0 ? (
    <div className={`carousel-wrapper ${className}`}>
      <Slider className={`carousel${name ? `-${name}` : ''}`} {...settings}>
        {children}
      </Slider>
    </div>
  ) : (
    <></>
  );
};
